{
  "v8e.lancements.liste.aucun_brouillon": "No step saved",
  "v8e.lancements.liste.cree": "Created by {{qui}} on {{depuis}}",
  "v8e.lancements.liste.membre": "You are a member",
  "v8e.lancements.liste.non_membre": "Organisation launch: you are not a member",
  "v8e.lancements.liste.pas": "Step {{k}} of {{total}} reached",
  "v8e.lancements.liste.programme": "programme {{nom}}",
  "v8e.lancements.liste.quoi": "the launches to finish",
  "v8e.lancements.liste.reprendre": "Resume the launch of {{nom}}",
  "v8e.lancements.liste.resume": "{{n}} launch(es) to finish in the organisation, {{vous}} of them yours.",
  "v8e.lancements.liste.vide": "No launch to finish: every project of the organisation is launched.",
  "v8e.lancements.onglet.lancements": "Launches to finish ({{n}})",
  "v8e.lancements.onglet.projets": "Projects",
  "v8e.lancements.onglets": "Organisation projects",
  "v8e.lancements.projet.ajouter": "Add a component",
  "v8e.lancements.projet.aucun_composant": "No component: add at least one.",
  "v8e.lancements.projet.baseline_existante": "Baseline v{{v}} already exists.",
  "v8e.lancements.projet.baseline_v1_annoncee": "Finishing the launch writes technology baseline v1; afterwards it only changes through a change request.",
  "v8e.lancements.projet.brouillon_enregistre": "Draft saved.",
  "v8e.lancements.projet.composants": "Application components",
  "v8e.lancements.projet.composition_non_qualifiee": "Composition not qualified: {{motifs}}",
  "v8e.lancements.projet.composition_qualifiee": "Composition qualified.",
  "v8e.lancements.projet.deja_termine": "Launch finished: baseline v1 exists.",
  "v8e.lancements.projet.demander_derogation": "Request a waiver",
  "v8e.lancements.projet.dialogue_non_disponible": "This dialogue is not available yet in this version.",
  "v8e.lancements.projet.echec_brouillon": "The draft could not be saved; nothing changed.",
  "v8e.lancements.projet.echec_fin": "The launch could not be finished; no baseline was written.",
  "v8e.lancements.projet.enregistrer": "Save draft",
  "v8e.lancements.projet.enregistrer_quitter": "Save and leave",
  "v8e.lancements.projet.etape.composition": "Technical composition",
  "v8e.lancements.projet.etape.recapitulatif": "Summary",
  "v8e.lancements.projet.etape.technologies": "Technologies by category",
  "v8e.lancements.projet.etapes": "Launch steps",
  "v8e.lancements.projet.inacheve": "Launch unfinished: generation and delivery stay refused until it ends.",
  "v8e.lancements.projet.mode.pile_prete": "A ready-to-use stack",
  "v8e.lancements.projet.mode.sur_mesure": "A custom application (components)",
  "v8e.lancements.projet.modele_sans_composition": "This project's template has no application to compose.",
  "v8e.lancements.projet.modifier": "Edit",
  "v8e.lancements.projet.piles": "the proposable stacks",
  "v8e.lancements.projet.piles_vide": "No proposable stack: the catalogue is empty, use the starter set.",
  "v8e.lancements.projet.plateforme": "Target platform",
  "v8e.lancements.projet.plateforme_absente": "The organisation catalogue offers no target platform.",
  "v8e.lancements.projet.plateforme_non_precisee": "Not specified",
  "v8e.lancements.projet.plus_tard": "Later",
  "v8e.lancements.projet.precedente": "Previous step",
  "v8e.lancements.projet.que_construisez_vous": "What are you building?",
  "v8e.lancements.projet.quoi": "the project launch",
  "v8e.lancements.projet.recapitulatif": "the summary",
  "v8e.lancements.projet.retirer": "Remove {{role}}",
  "v8e.lancements.projet.retirer_consequence": "Its links are removed with it; the composition qualification is recomputed.",
  "v8e.lancements.projet.retirer_titre": "Remove the {{role}} component?",
  "v8e.lancements.projet.retirer_verbe": "Remove",
  "v8e.lancements.projet.retour_projets": "Back to projects",
  "v8e.lancements.projet.role.donnees": "Data",
  "v8e.lancements.projet.role.interface": "Interface",
  "v8e.lancements.projet.role.service": "Service",
  "v8e.lancements.projet.role.service_de_plateforme": "Platform service",
  "v8e.lancements.projet.suivante": "Next: {{nom}}",
  "v8e.lancements.projet.terminer": "Finish the launch",
  "v8e.lancements.projet.titre_etape": "Step {{k}} of {{total}}: {{nom}}",
  "v8e.lancements.raison.parametres": "Resuming this launch requires “Change project settings” on this project; held by: {{detenteurs}}.",
  "v8e.lancements.raison.proprietaire_inconnu": "the project owner"
}
